import { Rule } from "@siteimprove/alfa-act";
import { DOM, Role } from "@siteimprove/alfa-aria";
import { Element, Namespace, Node } from "@siteimprove/alfa-dom";
import { Refinement } from "@siteimprove/alfa-refinement";
import { Err, Ok } from "@siteimprove/alfa-result";
import { Criterion } from "@siteimprove/alfa-wcag";
import * as aria from "@siteimprove/alfa-aria";
import { expectation } from "../common/act/expectation.js";
import { WithRole } from "../common/diagnostic/with-role.js";
import { Scope, Stability } from "../tags/index.js";
const { hasRole, isIncludedInTheAccessibilityTree } = DOM;
const { hasAttribute, hasNamespace, isElement } = Element;
const { and, equals } = Refinement;
export default Rule.Atomic.of({
    uri: "https://alfa.siteimprove.com/rules/sia-r68",
    requirements: [Criterion.of("1.3.1")],
    tags: [Scope.Component, Stability.Stable],
    evaluate({ device, document }) {
        return {
            applicability() {
                return visit(document, device);
            },
            expectations(target) {
                return {
                    1: expectation(hasRequiredChildren(device)(target), () => Outcomes.HasCorrectOwnedElements(WithRole.getRoleName(target, device)), () => Outcomes.HasIncorrectOwnedElements(WithRole.getRoleName(target, device))),
                };
            },
        };
    },
});
/**
 * @public
 */
export var Outcomes;
(function (Outcomes) {
    Outcomes.HasCorrectOwnedElements = (role) => Ok.of(WithRole.of(`The element owns elements as required by its semantic role`, role));
    Outcomes.HasIncorrectOwnedElements = (role) => Err.of(WithRole.of(`The element owns no elements as required by its semantic role`, role));
})(Outcomes || (Outcomes = {}));
function hasRequiredChildren(device) {
    return (element) => {
        const node = aria.Node.from(element, device);
        return node.role
            .filter((role) => role.hasRequiredChildren())
            .every((role) => node
            .children()
            .filter((node) => isElement(node.node))
            .some(isRequiredChild(role.requiredChildren)));
    };
}
function isRequiredChild(requiredChildren) {
    return (node) => requiredChildren.some((roles) => isRequiredChild(roles)(node));
    function isRequiredChild(requiredChildren) {
        return (node) => {
            const [role, ...rest] = requiredChildren;
            if (node.role.some(Role.hasName(role))) {
                return (rest.length === 0 ||
                    node
                        .children()
                        .filter((node) => isElement(node.node))
                        .some(isRequiredChild(rest)));
            }
            return false;
        };
    }
}
/**
 * Collect all descendants of the given node where the descendant:
 *
 * - is a HTML or SVG element, included in the accessibility tree, with a role
 *   requiring specific children; and
 * - does not have an `aria-busy` ancestor.
 */
function* visit(node, device) {
    if (and(isElement, hasAttribute("aria-busy", equals("true")))(node)) {
        return;
    }
    if (and(isElement, and(hasNamespace(Namespace.HTML, Namespace.SVG), isIncludedInTheAccessibilityTree(device), hasRole(device, (role) => role.hasRequiredChildren())))(node)) {
        yield node;
    }
    for (const child of node.children(Node.fullTree)) {
        yield* visit(child, device);
    }
}
//# sourceMappingURL=rule.js.map